import {serverStringToBrowserDate} from "../utils/date-utils";
import fetchWrapper, {putWrapper} from "../utils/fetchWrapper";
/*
let host = null;
if (process) {
  host = process.env.HOST;
} else {
  const { HOST } = get();
  host = HOST;
}*/

export class mockProgramTreeService {
  constructor(
    areas = [],
    regions = [],
    coordinators = [],
    programs = [],
    years = [],
    terms = [],
    delay = 0
  ) {
    this.areas = areas;
    this.regions = regions;
    this.coordinators = coordinators;
    this.programs = programs;
    this.years = years;
    this.terms = terms;
    this.delay = delay;
  }

  getNavigation(areaId, regionId, coordinatorId, programId, yearId, termId) {
    let useAreaId = parseInt(areaId);
    let useRegionId = parseInt(regionId);
    let useCoordinatorId = parseInt(coordinatorId);
    let useProgramId = parseInt(programId);
    let useYearId = parseInt(yearId);
    let useTermId = parseInt(termId);

    const p = new Promise((resolve) => {
      const area = this.areas.find((a) => a.id === useAreaId);
      const region = this.regions.find((r) => r.id === useRegionId);
      const coordinator = this.coordinators.find(
        (r) => r.id === useCoordinatorId
      );
      const program = this.programs.find((p) => p.id === useProgramId);
      const year = this.years.find((y) => y.id === useYearId);
      const term = this.terms.find((t) => t.id === useTermId);
      resolve({
        areas: this.areas,
        area: area,
        regions: area ? this.regions : [],
        coordinator: coordinator,
        coordinators: region ? this.coordinators : [],
        region: region,
        programs: region ? this.programs : [],
        program: program,
        years: program ? this.years : [],
        year: year,
        terms: year ? this.terms : [],
        term: term,
      });
    });
    return p;
  }

  searchByProgramNumber() {
    return this.getNavigation(); //stub that gives us whatever we stubbed in or a blank promise.
  }
}

export class apiProgramTreeService {
  constructor() {
    this.areas = [];
    this.regions = [];
    this.coordinators = [];
    this.programs = [];
    this.years = [];
    this.terms = [];
  }

  getNavigation = async function (
    areaId,
    regionId,
    coordinatorId,
    programId,
    yearId,
    termId,
    limitToManageablePrograms = false
  ) {
    try {
      let path = `api/navigation`;
      if (areaId) {
        path = `${path}?areaId=${areaId}`;
        if (regionId && regionId !== "na") {
          path = `${path}&regionId=${regionId}`;
        }
        if (coordinatorId && coordinatorId !== "na") {
          path = `${path}&coordinatorId=${coordinatorId}`;
        }
        if (programId) {
          path = `${path}&programId=${programId}`;
        }
        if (yearId) {
          path = `${path}&yearId=${yearId}`;
        }
        if (termId) {
          path = `${path}&termId=${termId}`;
        }
      }
      if (limitToManageablePrograms) {
        if (path.indexOf('?') > -1) {
          path = `${path}&limitToManageablePrograms=true`;
        } else {
          path = `${path}?limitToManageablePrograms=true`;
        }
      }
      path = `${path}&t=${new Date().valueOf()}`; //ensure we don't get a cached result
      let json = await fetchWrapper({ url: path});
      if (json.years) {
        json.years = json.years.map(y => {
          return {...y, startDate: serverStringToBrowserDate(y.startDate), endDate: serverStringToBrowserDate(y.endDate)}
        })
      }
      if (json.year) {
        json.year.startDate = serverStringToBrowserDate(json.year.startDate);
        json.year.endDate = serverStringToBrowserDate(json.year.endDate);
      }
      if (json.terms) {
        json.terms = json.terms.map(t => {
          return {...t, startDate: serverStringToBrowserDate(t.startDate), endDate: serverStringToBrowserDate(t.endDate)}
        })
      }
      if (json.term) {
        json.term.startDate = serverStringToBrowserDate(json.term.startDate);
        json.term.endDate = serverStringToBrowserDate(json.term.endDate);
      }
      return json;
    } catch (e) {
      console.log(`get navigation: ${e}`);
      throw e;
    }
  };

  getLastActive = async function () {
    try {
      const data = await fetchWrapper({
        url: `api/navigation/last`,
      });
      return data;
    } catch (e) {
      console.log(`get last active: ${e}`);
      throw e;
    }
  };

  getLastActiveSetting = async function () {
    try {
      const data = await fetchWrapper({
        url: `api/settings/lastactive`,
      });
      return data;
    } catch (e) {
      console.log(`get last active setting: ${e}`);
      throw e;
    }
  };
  setLastActive = async function (
    areaId,
    regionId,
    coordinatorId,
    programId,
    yearId,
    termId
  ) {
    try {
      /*var p = new Promise(resolve => resolve({}));
    return p;*/
      let path = `api/settings/lastactive`;
      const data = {
        areaId: areaId,
        regionId: regionId === "na" ? null : regionId,
        coordinatorId: coordinatorId === "na" ? null : coordinatorId,
        programId: programId,
        yearId: yearId,
        termId: termId,
      };
      let json = await putWrapper({url:path, data});

      return json;
    } catch (e) {
      //set last active returns a true when it succeeds, so I'll do a false for any errors
      return false;
    }
  };

  searchByProgramNumber = async function (prog) {
    try {
      let path = `api/navigation/programnumber/${prog}`;

      let json = await fetchWrapper({ url: path });

      return json;
    } catch (e) {
      console.log(`search by program number: ${e}`);
    }
  };
}

export default apiProgramTreeService;
